(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Import SASS

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */ (function() {
    var isIe = /(trident|msie)/i.test(navigator.userAgent);
    if (isIe && document.getElementById && window.addEventListener) window.addEventListener('hashchange', function() {
        var id = location.hash.substring(1), element;
        if (!/^[A-z0-9_-]+$/.test(id)) return;
        element = document.getElementById(id);
        if (element) {
            if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) element.tabIndex = -1;
            element.focus();
        }
    }, false);
})();


(function($) {
    // generate map
    function new_map($el) {
        // var
        var $markers = $el.find('.marker');
        // vars
        var args = {
            zoom: 16,
            disableDefaultUI: true,
            mapTypeControl: false,
            streetViewControl: false,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#f5f5f2"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.attraction",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi.business",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.medical",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.place_of_worship",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.school",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi.sports_complex",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "stylers": [
                        {
                            "color": "#71c8d4"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "stylers": [
                        {
                            "color": "#e5e8e7"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "stylers": [
                        {
                            "color": "#8ba129"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "poi.sports_complex",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#c7c7c7"
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "stylers": [
                        {
                            "color": "#a0d3d3"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "stylers": [
                        {
                            "color": "#91b65d"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "stylers": [
                        {
                            "gamma": 1.51
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi.government",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road"
                },
                {
                    "featureType": "road"
                },
                {},
                {
                    "featureType": "road.highway"
                }
            ]
        };
        // create map	        	
        var map = new google.maps.Map($el[0], args);
        // add a markers reference
        map.markers = [];
        // add markers
        $markers.each(function() {
            add_marker($(this), map);
        });
        // center map
        center_map(map);
        return map;
    }
    // add the marker
    function add_marker($marker, map) {
        // var
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            icon: '/wp-content/themes/ucg/img/map-marker.png',
            map: map
        });
        // add to array
        map.markers.push(marker);
        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });
            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open(map, marker);
            });
        }
    }
    // center the map
    function center_map(map) {
        // vars
        var bounds = new google.maps.LatLngBounds();
        // loop through all markers and create bounds
        $.each(map.markers, function(i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });
        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else // fit to bounds
        map.fitBounds(bounds);
    }
    // embed it
    var map = null;
    $(document).ready(function() {
        $('.acf-map').each(function() {
            // create map
            map = new_map($(this));
        });
    });
})(jQuery);


var $bfa8a26111c883c3$var$SimpleTabs = function SimpleTabs(e) {
    var t;
    var n = function n() {
        var _$e = this;
        this.tab;
        this.pane;
        this.setClick = function() {
            _$e.tab.addEventListener("click", _$e.showThisTab);
        };
        this.showThisTab = function() {
            if (_$e !== t) {
                t.pane.className = t.pane.className.replace("active-page", "");
                t.tab.className = t.tab.className.replace("active", "");
                _$e.pane.className = _$e.pane.className + " active-page";
                _$e.tab.className = _$e.tab.className + " active";
                t = _$e;
            }
        };
    };
    var r = e;
    var i;
    var s = r.getElementsByTagName("li");
    for(i = 0; i < s.length; ++i){
        var o = new n;
        o.tab = s[i];
        var u = s[i].className;
        var a = u.split(" ")[0];
        o.pane = document.getElementById(a);
        o.setClick();
        if (u.indexOf("active") > -1) t = o;
    }
};


var $31467fba5e5d38e9$exports = {};
/*! npm.im/object-fit-images 3.2.4 */ 'use strict';
var $31467fba5e5d38e9$var$OFI = 'bfred-it:object-fit-images';
var $31467fba5e5d38e9$var$propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var $31467fba5e5d38e9$var$testImg = typeof Image === 'undefined' ? {
    style: {
        'object-position': 1
    }
} : new Image();
var $31467fba5e5d38e9$var$supportsObjectFit = 'object-fit' in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsObjectPosition = 'object-position' in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsOFI = 'background-size' in $31467fba5e5d38e9$var$testImg.style;
var $31467fba5e5d38e9$var$supportsCurrentSrc = typeof $31467fba5e5d38e9$var$testImg.currentSrc === 'string';
var $31467fba5e5d38e9$var$nativeGetAttribute = $31467fba5e5d38e9$var$testImg.getAttribute;
var $31467fba5e5d38e9$var$nativeSetAttribute = $31467fba5e5d38e9$var$testImg.setAttribute;
var $31467fba5e5d38e9$var$autoModeEnabled = false;
function $31467fba5e5d38e9$var$createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
}
function $31467fba5e5d38e9$var$polyfillCurrentSrc(el) {
    if (el.srcset && !$31467fba5e5d38e9$var$supportsCurrentSrc && window.picturefill) {
        var pf = window.picturefill._;
        // parse srcset with picturefill where currentSrc isn't available
        if (!el[pf.ns] || !el[pf.ns].evaled) // force synchronous srcset parsing
        pf.fillImg(el, {
            reselect: true
        });
        if (!el[pf.ns].curSrc) {
            // force picturefill to parse srcset
            el[pf.ns].supported = false;
            pf.fillImg(el, {
                reselect: true
            });
        }
        // retrieve parsed currentSrc, if any
        el.currentSrc = el[pf.ns].curSrc || el.src;
    }
}
function $31467fba5e5d38e9$var$getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while((parsed = $31467fba5e5d38e9$var$propRegex.exec(style)) !== null)props[parsed[1]] = parsed[2];
    return props;
}
function $31467fba5e5d38e9$var$setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = $31467fba5e5d38e9$var$createPlaceholder(width || 1, height || 0);
    // Only set placeholder if it's different
    if ($31467fba5e5d38e9$var$nativeGetAttribute.call(img, 'src') !== placeholder) $31467fba5e5d38e9$var$nativeSetAttribute.call(img, 'src', placeholder);
}
function $31467fba5e5d38e9$var$onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) callback(img);
    else setTimeout($31467fba5e5d38e9$var$onImageReady, 100, img, callback);
}
function $31467fba5e5d38e9$var$fixOne(el) {
    var style = $31467fba5e5d38e9$var$getStyle(el);
    var ofi = el[$31467fba5e5d38e9$var$OFI];
    style['object-fit'] = style['object-fit'] || 'fill'; // default value
    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
        // fill is the default behavior so no action is necessary
        if (style['object-fit'] === 'fill') return;
        // Where object-fit is supported and object-position isn't (Safari < 10)
        if (!ofi.skipTest && // unless user wants to apply regardless of browser support
        $31467fba5e5d38e9$var$supportsObjectFit && // if browser already supports object-fit
        !style['object-position'] // unless object-position is used
        ) return;
    }
    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
        ofi.img = new Image(el.width, el.height);
        ofi.img.srcset = $31467fba5e5d38e9$var$nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
        ofi.img.src = $31467fba5e5d38e9$var$nativeGetAttribute.call(el, "data-ofi-src") || el.src;
        // preserve for any future cloneNode calls
        // https://github.com/bfred-it/object-fit-images/issues/53
        $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-src", el.src);
        if (el.srcset) $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
        $31467fba5e5d38e9$var$setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);
        // remove srcset because it overrides src
        if (el.srcset) el.srcset = '';
        try {
            $31467fba5e5d38e9$var$keepSrcUsable(el);
        } catch (err) {
            if (window.console) console.warn('https://bit.ly/ofi-old-browser');
        }
    }
    $31467fba5e5d38e9$var$polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = "url(\"" + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + "\")";
    el.style.backgroundPosition = style['object-position'] || 'center';
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundOrigin = 'content-box';
    if (/scale-down/.test(style['object-fit'])) $31467fba5e5d38e9$var$onImageReady(ofi.img, function() {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) el.style.backgroundSize = 'contain';
        else el.style.backgroundSize = 'auto';
    });
    else el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
    $31467fba5e5d38e9$var$onImageReady(ofi.img, function(img) {
        $31467fba5e5d38e9$var$setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
}
function $31467fba5e5d38e9$var$keepSrcUsable(el) {
    var descriptors = {
        get: function get(prop) {
            return el[$31467fba5e5d38e9$var$OFI].img[prop ? prop : 'src'];
        },
        set: function set(value, prop) {
            el[$31467fba5e5d38e9$var$OFI].img[prop ? prop : 'src'] = value;
            $31467fba5e5d38e9$var$nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
            $31467fba5e5d38e9$var$fixOne(el);
            return value;
        }
    };
    Object.defineProperty(el, 'src', descriptors);
    Object.defineProperty(el, 'currentSrc', {
        get: function get() {
            return descriptors.get('currentSrc');
        }
    });
    Object.defineProperty(el, 'srcset', {
        get: function get() {
            return descriptors.get('srcset');
        },
        set: function set(ss) {
            return descriptors.set(ss, 'srcset');
        }
    });
}
function $31467fba5e5d38e9$var$hijackAttributes() {
    function getOfiImageMaybe(el, name) {
        return el[$31467fba5e5d38e9$var$OFI] && el[$31467fba5e5d38e9$var$OFI].img && (name === 'src' || name === 'srcset') ? el[$31467fba5e5d38e9$var$OFI].img : el;
    }
    if (!$31467fba5e5d38e9$var$supportsObjectPosition) {
        HTMLImageElement.prototype.getAttribute = function(name) {
            return $31467fba5e5d38e9$var$nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
        };
        HTMLImageElement.prototype.setAttribute = function(name, value) {
            return $31467fba5e5d38e9$var$nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
        };
    }
}
function $31467fba5e5d38e9$var$fix(imgs, opts) {
    var startAutoMode = !$31467fba5e5d38e9$var$autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || 'img';
    if ($31467fba5e5d38e9$var$supportsObjectPosition && !opts.skipTest || !$31467fba5e5d38e9$var$supportsOFI) return false;
    // use imgs as a selector or just select all images
    if (imgs === 'img') imgs = document.getElementsByTagName('img');
    else if (typeof imgs === 'string') imgs = document.querySelectorAll(imgs);
    else if (!('length' in imgs)) imgs = [
        imgs
    ];
    // apply fix to all
    for(var i = 0; i < imgs.length; i++){
        imgs[i][$31467fba5e5d38e9$var$OFI] = imgs[i][$31467fba5e5d38e9$var$OFI] || {
            skipTest: opts.skipTest
        };
        $31467fba5e5d38e9$var$fixOne(imgs[i]);
    }
    if (startAutoMode) {
        document.body.addEventListener('load', function(e) {
            if (e.target.tagName === 'IMG') $31467fba5e5d38e9$var$fix(e.target, {
                skipTest: opts.skipTest
            });
        }, true);
        $31467fba5e5d38e9$var$autoModeEnabled = true;
        imgs = 'img'; // reset to a generic selector for watchMQ
    }
    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) window.addEventListener('resize', $31467fba5e5d38e9$var$fix.bind(null, imgs, {
        skipTest: opts.skipTest
    }));
}
$31467fba5e5d38e9$var$fix.supportsObjectFit = $31467fba5e5d38e9$var$supportsObjectFit;
$31467fba5e5d38e9$var$fix.supportsObjectPosition = $31467fba5e5d38e9$var$supportsObjectPosition;
$31467fba5e5d38e9$var$hijackAttributes();
$31467fba5e5d38e9$exports = $31467fba5e5d38e9$var$fix;


var $cc0041760c307885$exports = {};
function $1968e3edfc5cfc11$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


!function(e, t) {
    $cc0041760c307885$exports = t();
}("undefined" != typeof self ? self : undefined, function() {
    return function(e) {
        function t(r) {
            if (i[r]) return i[r].exports;
            var n = i[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
        }
        var i = {};
        return t.m = e, t.c = i, t.d = function(e, i, r) {
            t.o(e, i) || Object.defineProperty(e, i, {
                configurable: !1,
                enumerable: !0,
                get: r
            });
        }, t.n = function(e) {
            var i = e && e.__esModule ? function i() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(i, "a", i), i;
        }, t.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, t, i) {
            "use strict";
            function r(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = "function" == typeof Symbol && "symbol" == (0, $1968e3edfc5cfc11$export$71511d61b312f219)(Symbol.iterator) ? function n(e) {
                return typeof e === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(e);
            }, s = function() {
                function e(e, t) {
                    for(var i = 0; i < t.length; i++){
                        var r = t[i];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                return function(t, i, r) {
                    return i && e(t.prototype, i), r && e(t, r), t;
                };
            }(), l = function() {
                function e(t) {
                    var i = this;
                    if (r(this, e), this.config = e.mergeSettings(t), this.selector = "string" == typeof this.config.selector ? document.querySelector(this.config.selector) : this.config.selector, null === this.selector) throw new Error("Something wrong with your selector \uD83D\uDE2D");
                    this.resolveSlidesNumber(), this.selectorWidth = this.selector.offsetWidth, this.innerElements = [].slice.call(this.selector.children), this.currentSlide = this.config.loop ? this.config.startIndex % this.innerElements.length : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage)), this.transformProperty = e.webkitOrNot(), [
                        "resizeHandler",
                        "touchstartHandler",
                        "touchendHandler",
                        "touchmoveHandler",
                        "mousedownHandler",
                        "mouseupHandler",
                        "mouseleaveHandler",
                        "mousemoveHandler",
                        "clickHandler"
                    ].forEach(function(e) {
                        i[e] = i[e].bind(i);
                    }), this.init();
                }
                return s(e, [
                    {
                        key: "attachEvents",
                        value: function value() {
                            window.addEventListener("resize", this.resizeHandler), this.config.draggable && (this.pointerDown = !1, this.drag = {
                                startX: 0,
                                endX: 0,
                                startY: 0,
                                letItGo: null,
                                preventClick: !1
                            }, this.selector.addEventListener("touchstart", this.touchstartHandler), this.selector.addEventListener("touchend", this.touchendHandler), this.selector.addEventListener("touchmove", this.touchmoveHandler), this.selector.addEventListener("mousedown", this.mousedownHandler), this.selector.addEventListener("mouseup", this.mouseupHandler), this.selector.addEventListener("mouseleave", this.mouseleaveHandler), this.selector.addEventListener("mousemove", this.mousemoveHandler), this.selector.addEventListener("click", this.clickHandler));
                        }
                    },
                    {
                        key: "detachEvents",
                        value: function value() {
                            window.removeEventListener("resize", this.resizeHandler), this.selector.removeEventListener("touchstart", this.touchstartHandler), this.selector.removeEventListener("touchend", this.touchendHandler), this.selector.removeEventListener("touchmove", this.touchmoveHandler), this.selector.removeEventListener("mousedown", this.mousedownHandler), this.selector.removeEventListener("mouseup", this.mouseupHandler), this.selector.removeEventListener("mouseleave", this.mouseleaveHandler), this.selector.removeEventListener("mousemove", this.mousemoveHandler), this.selector.removeEventListener("click", this.clickHandler);
                        }
                    },
                    {
                        key: "init",
                        value: function value() {
                            this.attachEvents(), this.selector.style.overflow = "hidden", this.selector.style.direction = this.config.rtl ? "rtl" : "ltr", this.buildSliderFrame(), this.config.onInit.call(this);
                        }
                    },
                    {
                        key: "buildSliderFrame",
                        value: function value() {
                            var _$e = this.selectorWidth / this.perPage, _$t = this.config.loop ? this.innerElements.length + 2 * this.perPage : this.innerElements.length;
                            this.sliderFrame = document.createElement("div"), this.sliderFrame.style.width = _$e * _$t + "px", this.enableTransition(), this.config.draggable && (this.selector.style.cursor = "-webkit-grab");
                            var i = document.createDocumentFragment();
                            if (this.config.loop) for(var r = this.innerElements.length - this.perPage; r < this.innerElements.length; r++){
                                var n = this.buildSliderFrameItem(this.innerElements[r].cloneNode(!0));
                                i.appendChild(n);
                            }
                            for(var s = 0; s < this.innerElements.length; s++){
                                var l = this.buildSliderFrameItem(this.innerElements[s]);
                                i.appendChild(l);
                            }
                            if (this.config.loop) for(var o = 0; o < this.perPage; o++){
                                var a = this.buildSliderFrameItem(this.innerElements[o].cloneNode(!0));
                                i.appendChild(a);
                            }
                            this.sliderFrame.appendChild(i), this.selector.innerHTML = "", this.selector.appendChild(this.sliderFrame), this.slideToCurrent();
                        }
                    },
                    {
                        key: "buildSliderFrameItem",
                        value: function value(e) {
                            var _$t = document.createElement("div");
                            return _$t.style.cssFloat = this.config.rtl ? "right" : "left", _$t.style.float = this.config.rtl ? "right" : "left", _$t.style.width = (this.config.loop ? 100 / (this.innerElements.length + 2 * this.perPage) : 100 / this.innerElements.length) + "%", _$t.appendChild(e), _$t;
                        }
                    },
                    {
                        key: "resolveSlidesNumber",
                        value: function value() {
                            if ("number" == typeof this.config.perPage) this.perPage = this.config.perPage;
                            else if ("object" === n(this.config.perPage)) {
                                this.perPage = 1;
                                for(var _$e in this.config.perPage)window.innerWidth >= _$e && (this.perPage = this.config.perPage[_$e]);
                            }
                        }
                    },
                    {
                        key: "prev",
                        value: function value() {
                            var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, _$t = arguments[1];
                            if (!(this.innerElements.length <= this.perPage)) {
                                var i = this.currentSlide;
                                if (this.config.loop) {
                                    if (this.currentSlide - _$e < 0) {
                                        this.disableTransition();
                                        var r = this.currentSlide + this.innerElements.length, n = this.perPage, s = r + n, l = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage), o = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
                                        this.sliderFrame.style[this.transformProperty] = "translate3d(" + (l + o) + "px, 0, 0)", this.currentSlide = r - _$e;
                                    } else this.currentSlide = this.currentSlide - _$e;
                                } else this.currentSlide = Math.max(this.currentSlide - _$e, 0);
                                i !== this.currentSlide && (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), _$t && _$t.call(this));
                            }
                        }
                    },
                    {
                        key: "next",
                        value: function value() {
                            var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, _$t = arguments[1];
                            if (!(this.innerElements.length <= this.perPage)) {
                                var i = this.currentSlide;
                                if (this.config.loop) {
                                    if (this.currentSlide + _$e > this.innerElements.length - this.perPage) {
                                        this.disableTransition();
                                        var r = this.currentSlide - this.innerElements.length, n = this.perPage, s = r + n, l = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage), o = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
                                        this.sliderFrame.style[this.transformProperty] = "translate3d(" + (l + o) + "px, 0, 0)", this.currentSlide = r + _$e;
                                    } else this.currentSlide = this.currentSlide + _$e;
                                } else this.currentSlide = Math.min(this.currentSlide + _$e, this.innerElements.length - this.perPage);
                                i !== this.currentSlide && (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), _$t && _$t.call(this));
                            }
                        }
                    },
                    {
                        key: "disableTransition",
                        value: function value() {
                            this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing;
                        }
                    },
                    {
                        key: "enableTransition",
                        value: function value() {
                            this.sliderFrame.style.webkitTransition = "all " + this.config.duration + "ms " + this.config.easing, this.sliderFrame.style.transition = "all " + this.config.duration + "ms " + this.config.easing;
                        }
                    },
                    {
                        key: "goTo",
                        value: function value(e, t) {
                            if (!(this.innerElements.length <= this.perPage)) {
                                var i = this.currentSlide;
                                this.currentSlide = this.config.loop ? e % this.innerElements.length : Math.min(Math.max(e, 0), this.innerElements.length - this.perPage), i !== this.currentSlide && (this.slideToCurrent(), this.config.onChange.call(this), t && t.call(this));
                            }
                        }
                    },
                    {
                        key: "slideToCurrent",
                        value: function value(e) {
                            var _$t = this, i = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide, r = (this.config.rtl ? 1 : -1) * i * (this.selectorWidth / this.perPage);
                            e ? requestAnimationFrame(function() {
                                requestAnimationFrame(function() {
                                    _$t.enableTransition(), _$t.sliderFrame.style[_$t.transformProperty] = "translate3d(" + r + "px, 0, 0)";
                                });
                            }) : this.sliderFrame.style[this.transformProperty] = "translate3d(" + r + "px, 0, 0)";
                        }
                    },
                    {
                        key: "updateAfterDrag",
                        value: function value() {
                            var _$e = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX), _$t = Math.abs(_$e), i = this.config.multipleDrag ? Math.ceil(_$t / (this.selectorWidth / this.perPage)) : 1, r = _$e > 0 && this.currentSlide - i < 0, n = _$e < 0 && this.currentSlide + i > this.innerElements.length - this.perPage;
                            _$e > 0 && _$t > this.config.threshold && this.innerElements.length > this.perPage ? this.prev(i) : _$e < 0 && _$t > this.config.threshold && this.innerElements.length > this.perPage && this.next(i), this.slideToCurrent(r || n);
                        }
                    },
                    {
                        key: "resizeHandler",
                        value: function value() {
                            this.resolveSlidesNumber(), this.currentSlide + this.perPage > this.innerElements.length && (this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage), this.selectorWidth = this.selector.offsetWidth, this.buildSliderFrame();
                        }
                    },
                    {
                        key: "clearDrag",
                        value: function value() {
                            this.drag = {
                                startX: 0,
                                endX: 0,
                                startY: 0,
                                letItGo: null,
                                preventClick: this.drag.preventClick
                            };
                        }
                    },
                    {
                        key: "touchstartHandler",
                        value: function value(e) {
                            -1 !== [
                                "TEXTAREA",
                                "OPTION",
                                "INPUT",
                                "SELECT"
                            ].indexOf(e.target.nodeName) || (e.stopPropagation(), this.pointerDown = !0, this.drag.startX = e.touches[0].pageX, this.drag.startY = e.touches[0].pageY);
                        }
                    },
                    {
                        key: "touchendHandler",
                        value: function value(e) {
                            e.stopPropagation(), this.pointerDown = !1, this.enableTransition(), this.drag.endX && this.updateAfterDrag(), this.clearDrag();
                        }
                    },
                    {
                        key: "touchmoveHandler",
                        value: function value(e) {
                            if (e.stopPropagation(), null === this.drag.letItGo && (this.drag.letItGo = Math.abs(this.drag.startY - e.touches[0].pageY) < Math.abs(this.drag.startX - e.touches[0].pageX)), this.pointerDown && this.drag.letItGo) {
                                e.preventDefault(), this.drag.endX = e.touches[0].pageX, this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing;
                                var _$t = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide, i = _$t * (this.selectorWidth / this.perPage), r = this.drag.endX - this.drag.startX, n = this.config.rtl ? i + r : i - r;
                                this.sliderFrame.style[this.transformProperty] = "translate3d(" + (this.config.rtl ? 1 : -1) * n + "px, 0, 0)";
                            }
                        }
                    },
                    {
                        key: "mousedownHandler",
                        value: function value(e) {
                            -1 !== [
                                "TEXTAREA",
                                "OPTION",
                                "INPUT",
                                "SELECT"
                            ].indexOf(e.target.nodeName) || (e.preventDefault(), e.stopPropagation(), this.pointerDown = !0, this.drag.startX = e.pageX);
                        }
                    },
                    {
                        key: "mouseupHandler",
                        value: function value(e) {
                            e.stopPropagation(), this.pointerDown = !1, this.selector.style.cursor = "-webkit-grab", this.enableTransition(), this.drag.endX && this.updateAfterDrag(), this.clearDrag();
                        }
                    },
                    {
                        key: "mousemoveHandler",
                        value: function value(e) {
                            if (e.preventDefault(), this.pointerDown) {
                                "A" === e.target.nodeName && (this.drag.preventClick = !0), this.drag.endX = e.pageX, this.selector.style.cursor = "-webkit-grabbing", this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing, this.sliderFrame.style.transition = "all 0ms " + this.config.easing;
                                var _$t = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide, i = _$t * (this.selectorWidth / this.perPage), r = this.drag.endX - this.drag.startX, n = this.config.rtl ? i + r : i - r;
                                this.sliderFrame.style[this.transformProperty] = "translate3d(" + (this.config.rtl ? 1 : -1) * n + "px, 0, 0)";
                            }
                        }
                    },
                    {
                        key: "mouseleaveHandler",
                        value: function value(e) {
                            this.pointerDown && (this.pointerDown = !1, this.selector.style.cursor = "-webkit-grab", this.drag.endX = e.pageX, this.drag.preventClick = !1, this.enableTransition(), this.updateAfterDrag(), this.clearDrag());
                        }
                    },
                    {
                        key: "clickHandler",
                        value: function value(e) {
                            this.drag.preventClick && e.preventDefault(), this.drag.preventClick = !1;
                        }
                    },
                    {
                        key: "remove",
                        value: function value(e, t) {
                            if (e < 0 || e >= this.innerElements.length) throw new Error("Item to remove doesn't exist \uD83D\uDE2D");
                            var i = e < this.currentSlide, r = this.currentSlide + this.perPage - 1 === e;
                            (i || r) && this.currentSlide--, this.innerElements.splice(e, 1), this.buildSliderFrame(), t && t.call(this);
                        }
                    },
                    {
                        key: "insert",
                        value: function value(e, t, i) {
                            if (t < 0 || t > this.innerElements.length + 1) throw new Error("Unable to inset it at this index \uD83D\uDE2D");
                            if (-1 !== this.innerElements.indexOf(e)) throw new Error("The same item in a carousel? Really? Nope \uD83D\uDE2D");
                            var r = t <= this.currentSlide > 0 && this.innerElements.length;
                            this.currentSlide = r ? this.currentSlide + 1 : this.currentSlide, this.innerElements.splice(t, 0, e), this.buildSliderFrame(), i && i.call(this);
                        }
                    },
                    {
                        key: "prepend",
                        value: function value(e, t) {
                            this.insert(e, 0), t && t.call(this);
                        }
                    },
                    {
                        key: "append",
                        value: function value(e, t) {
                            this.insert(e, this.innerElements.length + 1), t && t.call(this);
                        }
                    },
                    {
                        key: "destroy",
                        value: function value() {
                            var _$e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], _$t = arguments[1];
                            if (this.detachEvents(), this.selector.style.cursor = "auto", _$e) {
                                for(var i = document.createDocumentFragment(), r = 0; r < this.innerElements.length; r++)i.appendChild(this.innerElements[r]);
                                this.selector.innerHTML = "", this.selector.appendChild(i), this.selector.removeAttribute("style");
                            }
                            _$t && _$t.call(this);
                        }
                    }
                ], [
                    {
                        key: "mergeSettings",
                        value: function value(e) {
                            var _$t = {
                                selector: ".siema",
                                duration: 200,
                                easing: "ease-out",
                                perPage: 1,
                                startIndex: 0,
                                draggable: !0,
                                multipleDrag: !0,
                                threshold: 20,
                                loop: !1,
                                rtl: !1,
                                onInit: function onInit() {},
                                onChange: function onChange() {}
                            }, i = e;
                            for(var r in i)_$t[r] = i[r];
                            return _$t;
                        }
                    },
                    {
                        key: "webkitOrNot",
                        value: function value() {
                            return "string" == typeof document.documentElement.style.transform ? "transform" : "WebkitTransform";
                        }
                    }
                ]), e;
            }();
            t.default = l, e.exports = t.default;
        }
    ]);
});


var $be62d5f8765e73fc$exports = {};
/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */ 
!function(t, e) {
    $be62d5f8765e73fc$exports = e();
}(undefined, function() {
    return function(t) {
        function e(r) {
            if (n[r]) return n[r].exports;
            var i = n[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return t[r].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
        }
        var n = {};
        return e.m = t, e.c = n, e.p = "", e(0);
    }([
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    "default": t
                };
            }
            var i = n(2), o = r(i);
            t.exports = o["default"];
        },
        function(t, e) {
            function n(t) {
                var e = typeof t === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(t);
                return null != t && ("object" == e || "function" == e);
            }
            t.exports = n;
        },
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    "default": t
                };
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var i = n(9), o = r(i), u = n(3), f = r(u), s = n(4), c = function c() {
                if ("undefined" != typeof window) {
                    var t = 100, _$e = [
                        "scroll",
                        "resize",
                        "load"
                    ], _$n = {
                        history: []
                    }, _$r = {
                        offset: {},
                        threshold: 0,
                        test: s.inViewport
                    }, i = (0, o["default"])(function() {
                        _$n.history.forEach(function(t) {
                            _$n[t].check();
                        });
                    }, t);
                    _$e.forEach(function(t) {
                        return addEventListener(t, i);
                    }), window.MutationObserver && addEventListener("DOMContentLoaded", function() {
                        new MutationObserver(i).observe(document.body, {
                            attributes: !0,
                            childList: !0,
                            subtree: !0
                        });
                    });
                    var u = function u(t) {
                        if ("string" == typeof t) {
                            var _$e = [].slice.call(document.querySelectorAll(t));
                            return _$n.history.indexOf(t) > -1 ? _$n[t].elements = _$e : (_$n[t] = (0, f["default"])(_$e, _$r), _$n.history.push(t)), _$n[t];
                        }
                    };
                    return u.offset = function(t) {
                        if (void 0 === t) return _$r.offset;
                        var _$e = function e(t) {
                            return "number" == typeof t;
                        };
                        return [
                            "top",
                            "right",
                            "bottom",
                            "left"
                        ].forEach(_$e(t) ? function(e) {
                            return _$r.offset[e] = t;
                        } : function(n) {
                            return _$e(t[n]) ? _$r.offset[n] = t[n] : null;
                        }), _$r.offset;
                    }, u.threshold = function(t) {
                        return "number" == typeof t && t >= 0 && t <= 1 ? _$r.threshold = t : _$r.threshold;
                    }, u.test = function(t) {
                        return "function" == typeof t ? _$r.test = t : _$r.test;
                    }, u.is = function(t) {
                        return _$r.test(t, _$r);
                    }, u.offset(0), u;
                }
            };
            e["default"] = c();
        },
        function(t, e) {
            "use strict";
            function n(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = function() {
                function t(t, e) {
                    for(var n = 0; n < e.length; n++){
                        var r = e[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                    }
                }
                return function(e, n, r) {
                    return n && t(e.prototype, n), r && t(e, r), e;
                };
            }(), i = function() {
                function t(e, r) {
                    n(this, t), this.options = r, this.elements = e, this.current = [], this.handlers = {
                        enter: [],
                        exit: []
                    }, this.singles = {
                        enter: [],
                        exit: []
                    };
                }
                return r(t, [
                    {
                        key: "check",
                        value: function value() {
                            var _$t = this;
                            return this.elements.forEach(function(e) {
                                var n = _$t.options.test(e, _$t.options), r = _$t.current.indexOf(e), i = r > -1, o = n && !i, u = !n && i;
                                o && (_$t.current.push(e), _$t.emit("enter", e)), u && (_$t.current.splice(r, 1), _$t.emit("exit", e));
                            }), this;
                        }
                    },
                    {
                        key: "on",
                        value: function value(t, e) {
                            return this.handlers[t].push(e), this;
                        }
                    },
                    {
                        key: "once",
                        value: function value(t, e) {
                            return this.singles[t].unshift(e), this;
                        }
                    },
                    {
                        key: "emit",
                        value: function value(t, e) {
                            for(; this.singles[t].length;)this.singles[t].pop()(e);
                            for(var n = this.handlers[t].length; --n > -1;)this.handlers[t][n](e);
                            return this;
                        }
                    }
                ]), t;
            }();
            e["default"] = function(t, e) {
                return new i(t, e);
            };
        },
        function(t, e) {
            "use strict";
            function n(t, e) {
                var _$n = t.getBoundingClientRect(), r = _$n.top, i = _$n.right, o = _$n.bottom, u = _$n.left, f = _$n.width, s = _$n.height, c = {
                    t: o,
                    r: window.innerWidth - u,
                    b: window.innerHeight - r,
                    l: i
                }, a = {
                    x: e.threshold * f,
                    y: e.threshold * s
                };
                return c.t > e.offset.top + a.y && c.r > e.offset.right + a.x && c.b > e.offset.bottom + a.y && c.l > e.offset.left + a.x;
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.inViewport = n;
        },
        function(t, e) {
            (function(e) {
                var n = "object" == (typeof e === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(e)) && e && e.Object === Object && e;
                t.exports = n;
            }).call(e, function() {
                return this;
            }());
        },
        function(t, e, n) {
            var r = n(5), i = "object" == (typeof self === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(self)) && self && self.Object === Object && self, o = r || i || Function("return this")();
            t.exports = o;
        },
        function(t, e, n) {
            function r(t, e, n) {
                function r(e) {
                    var _$n = x, _$r = m;
                    return x = m = void 0, E = e, w = t.apply(_$r, _$n);
                }
                function a(t) {
                    return E = t, j = setTimeout(h, e), M ? r(t) : w;
                }
                function l(t) {
                    var _$n = t - O, _$r = t - E, i = e - _$n;
                    return _ ? c(i, g - _$r) : i;
                }
                function d(t) {
                    var _$n = t - O, _$r = t - E;
                    return void 0 === O || _$n >= e || _$n < 0 || _ && _$r >= g;
                }
                function h() {
                    var _$t = o();
                    return d(_$t) ? p(_$t) : void (j = setTimeout(h, l(_$t)));
                }
                function p(t) {
                    return j = void 0, T && x ? r(t) : (x = m = void 0, w);
                }
                function v() {
                    void 0 !== j && clearTimeout(j), E = 0, x = O = m = j = void 0;
                }
                function y() {
                    return void 0 === j ? w : p(o());
                }
                function b() {
                    var _$t = o(), _$n = d(_$t);
                    if (x = arguments, m = this, O = _$t, _$n) {
                        if (void 0 === j) return a(O);
                        if (_) return j = setTimeout(h, e), r(O);
                    }
                    return void 0 === j && (j = setTimeout(h, e)), w;
                }
                var x, m, g, w, j, O, E = 0, M = !1, _ = !1, T = !0;
                if ("function" != typeof t) throw new TypeError(f);
                return e = u(e) || 0, i(n) && (M = !!n.leading, _ = "maxWait" in n, g = _ ? s(u(n.maxWait) || 0, e) : g, T = "trailing" in n ? !!n.trailing : T), b.cancel = v, b.flush = y, b;
            }
            var i = n(1), o = n(8), u = n(10), f = "Expected a function", s = Math.max, c = Math.min;
            t.exports = r;
        },
        function(t, e, n) {
            var r = n(6), i = function i() {
                return r.Date.now();
            };
            t.exports = i;
        },
        function(t, e, n) {
            function r(t, e, n) {
                var _$r = !0, f = !0;
                if ("function" != typeof t) throw new TypeError(u);
                return o(n) && (_$r = "leading" in n ? !!n.leading : _$r, f = "trailing" in n ? !!n.trailing : f), i(t, e, {
                    leading: _$r,
                    maxWait: e,
                    trailing: f
                });
            }
            var i = n(7), o = n(1), u = "Expected a function";
            t.exports = r;
        },
        function(t, e) {
            function n(t) {
                return t;
            }
            t.exports = n;
        }
    ]);
});


// Veelgebruikte modules:
// ------------------------
// Lightbox		-->		import baguetteBox from 'baguettebox.js';
// Viewport		-->		import inView from 'in-view';
// Smoothscroll	-->		import MoveTo from 'moveto';
// Sticky div	-->		import Sticky from 'sticky-js';
// Slider		-->		import { tns } from 'tiny-slider/src/tiny-slider.module.js';
// Modals		-->		import modals from 'Modals';
// Hamburger menu
document.querySelector("#nav-toggle").addEventListener("click", function() {
    this.classList.toggle("active");
    var mainNav = document.querySelector('.main-navigation');
    mainNav.classList.toggle('toggled');
});
var $c55bff8fb8cf358b$var$faqToggle = document.querySelectorAll(".faq__question");
for(var $c55bff8fb8cf358b$var$i = 0; $c55bff8fb8cf358b$var$i < $c55bff8fb8cf358b$var$faqToggle.length; $c55bff8fb8cf358b$var$i++)$c55bff8fb8cf358b$var$faqToggle[$c55bff8fb8cf358b$var$i].onclick = function() {
    this.nextElementSibling.classList.toggle("active");
    this.querySelector('svg').classList.toggle('active');
};
// Object-fit fix
(0, (/*@__PURE__*/$parcel$interopDefault($31467fba5e5d38e9$exports)))();
if (document.querySelector(".video__start1")) document.querySelector(".video__start1").addEventListener("click", function() {
    document.querySelector("#videoContainer").innerHTML = '<iframe width="560" height="315" src="//www.youtube.com/embed/cv4v97KC02w?rel=0&amp;showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
});
if (document.querySelector(".video__start2")) document.querySelector(".video__start2").addEventListener("click", function() {
    document.querySelector("#videoContainer2").innerHTML = '<iframe width="560" height="315" src="//www.youtube.com/embed/s3kx62AV1v4?rel=0&amp;showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
});
if (document.querySelector(".video__start3")) document.querySelector(".video__start3").addEventListener("click", function() {
    document.querySelector("#videoContainer3").innerHTML = '<iframe width="560" height="315" src="//www.youtube.com/embed/tY79ZV8AXgs?rel=0&amp;showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
});
(0, (/*@__PURE__*/$parcel$interopDefault($be62d5f8765e73fc$exports)))('.home__text').once('enter', function() {
    document.querySelector(".home__text").classList.add("fadeInUp");
});
(0, (/*@__PURE__*/$parcel$interopDefault($be62d5f8765e73fc$exports)))('.cta__img').once('enter', function() {
    document.querySelector(".cta__img").classList.add("fadeIn");
});
(0, (/*@__PURE__*/$parcel$interopDefault($be62d5f8765e73fc$exports)))('.header__logoimg').once('enter', function() {
    document.querySelector(".header__logoimg").classList.add("fadeIn");
});
// WooCommerce single product add to cart via AJAX
if (document.body.classList.contains('single-product') && typeof window.jQuery !== 'undefined') {
    var $c55bff8fb8cf358b$var$$ = window.jQuery;
    var $c55bff8fb8cf358b$var$wcAjaxParams = window.wc_add_to_cart_params || window.wc_cart_fragments_params;
    var $c55bff8fb8cf358b$var$forms = document.querySelectorAll('form.cart');
    if ($c55bff8fb8cf358b$var$wcAjaxParams && $c55bff8fb8cf358b$var$wcAjaxParams.wc_ajax_url && $c55bff8fb8cf358b$var$forms.length) {
        var $c55bff8fb8cf358b$var$addToCartEndpoint = $c55bff8fb8cf358b$var$wcAjaxParams.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart');
        $c55bff8fb8cf358b$var$forms.forEach(function(form) {
            var addToCartButton = form.querySelector('.single_add_to_cart_button');
            if (!addToCartButton || form.classList.contains('grouped_form')) return;
            form.addEventListener('submit', function(event) {
                if (addToCartButton.classList.contains('disabled')) return;
                var variationIdInput = form.querySelector('input[name="variation_id"]');
                if (variationIdInput && !variationIdInput.value) return;
                event.preventDefault();
                var $form = $c55bff8fb8cf358b$var$$(form);
                var $button = $c55bff8fb8cf358b$var$$(addToCartButton);
                var requestData = $form.serializeArray();
                var buttonName = addToCartButton.getAttribute('name');
                var buttonValue = addToCartButton.getAttribute('value');
                var hasAddToCartField = requestData.some(function(field) {
                    return field.name === 'add-to-cart';
                });
                var hasProductIdField = requestData.some(function(field) {
                    return field.name === 'product_id';
                });
                if (buttonName && buttonValue && !hasAddToCartField) requestData.push({
                    name: buttonName,
                    value: buttonValue
                });
                if (buttonValue && !hasProductIdField) requestData.push({
                    name: 'product_id',
                    value: buttonValue
                });
                var loadingStartedAt = Date.now();
                var addToCartSucceeded = false;
                $button.removeClass('added').addClass('loading');
                $c55bff8fb8cf358b$var$$.ajax({
                    type: 'POST',
                    url: $c55bff8fb8cf358b$var$addToCartEndpoint,
                    data: $c55bff8fb8cf358b$var$$.param(requestData),
                    dataType: 'json',
                    success: function success(response) {
                        if (!response) return;
                        if (response.error && response.product_url) {
                            window.location = response.product_url;
                            return;
                        }
                        if (response.error) {
                            form.submit();
                            return;
                        }
                        if (response.fragments) Object.keys(response.fragments).forEach(function(selector) {
                            $c55bff8fb8cf358b$var$$(selector).replaceWith(response.fragments[selector]);
                        });
                        addToCartSucceeded = true;
                        $c55bff8fb8cf358b$var$$(document.body).trigger('added_to_cart', [
                            response.fragments,
                            response.cart_hash,
                            $button
                        ]);
                    },
                    error: function error() {
                        form.submit();
                    },
                    complete: function complete() {
                        var clearLoadingState = function clearLoadingState() {
                            $button.removeClass('loading');
                            if (addToCartSucceeded) $button.addClass('added');
                        };
                        var elapsedTime = Date.now() - loadingStartedAt;
                        var minLoadingMs = 250;
                        if (elapsedTime < minLoadingMs) {
                            setTimeout(clearLoadingState, minLoadingMs - elapsedTime);
                            return;
                        }
                        clearLoadingState();
                    }
                });
            });
        });
    }
}
if (document.querySelector(".siema__header")) {
    var $c55bff8fb8cf358b$var$headerSiema = new (0, (/*@__PURE__*/$parcel$interopDefault($cc0041760c307885$exports)))({
        selector: '.siema__header',
        interval: 10000,
        duration: 500,
        perPage: 1,
        startIndex: 0,
        draggable: true,
        threshold: 20,
        loop: true
    });
    // listen for keydown event
    setInterval(function() {
        return $c55bff8fb8cf358b$var$headerSiema.next();
    }, 5000);
}

})();
//# sourceMappingURL=app.js.map
